import { FINANCIAL_DOCUMENT_PRINT_TEMPLATE } from 'src/features/billing/utils/types';
import { billingMessages } from 'src/features/billing/utils/messages';

export const FINANCIAL_DOC_TEMPLATE_TRANSLATION_MAP: Record<
    FINANCIAL_DOCUMENT_PRINT_TEMPLATE,
    { id: string; defaultMessage: string }
> = {
    [FINANCIAL_DOCUMENT_PRINT_TEMPLATE.STANDARD_NO_LOGO]: billingMessages.standardNoLogo,
    [FINANCIAL_DOCUMENT_PRINT_TEMPLATE.STANDARD_LEFT_LOGO]: billingMessages.standardLeftLogo,
    [FINANCIAL_DOCUMENT_PRINT_TEMPLATE.STANDARD_RIGHT_LOGO]: billingMessages.standardRightLogo,
};
